import React, { PropTypes, PureComponent } from 'react';

import { labelActive, container, label } from '../../styles.module.css';

class PlacepickerPresetCountry extends PureComponent {
  handleChange = () => {
    const {
      countryName,
      onClick,
      viewportNorthEastLat,
      viewportNorthEastLong,
      viewportSouthWestLat,
      viewportSouthWestLong,
    } = this.props;

    onClick({
      target: {
        name: 'location',
        value: {
          name: countryName,
          types: ['bounds'],
          geometry: {
            viewport: {
              getNorthEast: () => {
                return ({
                  lat: () => { return viewportNorthEastLat; },
                  lng: () => { return viewportNorthEastLong; },
                });
              },
              getSouthWest: () => {
                return ({
                  lat: () => { return viewportSouthWestLat; },
                  lng: () => { return viewportSouthWestLong; },
                });
              },
            },
          },
        },
      },
      type: 'change',
    });
  }

  render() {
    const { countryName, className, selectedLocation } = this.props;

    return (
      <div className={[container, className].join(' ')}>
        <label
          className={selectedLocation === countryName ? labelActive : label}
          htmlFor={countryName}
          onClick={this.handleChange}
        >{countryName}
          <input
            id={countryName}
            type="hidden"
            onClick={this.handleChange}
            value={countryName}
            ref={(node) => { this.input = node; }}
          />
        </label>
      </div>
    );
  }
}

export default PlacepickerPresetCountry;

PlacepickerPresetCountry.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Function called on place select.
   */
  onClick: PropTypes.func.isRequired,
  /**
   * String name of location (e.g. Kettering).
   */
  countryName: PropTypes.string.isRequired,
  /**
   * String name of currently selected location. Used to compare against
   * name of preset to determine whether option should be made bold.
   */
  selectedLocation: PropTypes.string,
  /**
   * Latitide for NE country bounds.
   */
  viewportNorthEastLat: PropTypes.number,
  /**
   * Longitude for NE country bounds.
   */
  viewportNorthEastLong: PropTypes.number,
  /**
   * Latitide for SW country bounds.
   */
  viewportSouthWestLat: PropTypes.number,
  /**
   * Longitude for SW country bounds.
   */
  viewportSouthWestLong: PropTypes.number,

};

PlacepickerPresetCountry.defaultProps = {
  className: '',
  viewportNorthEastLat: undefined,
  viewportNorthEastLong: undefined,
  viewportSouthWestLat: undefined,
  viewportSouthWestLong: undefined,
  selectedLocation: '',
};



// WEBPACK FOOTER //
// ./app/src/components/PlacepickerPreset/components/PlacepickerPresetCountry/index.jsx